import React from 'react';

export default function Modal({ open, onClose, children, hideCloseButton = false }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        background: 'rgba(0,0,0,0.55)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backdropFilter: 'blur(3px)'
      }}
      onClick={!hideCloseButton ? onClose : undefined}
    >
      <div
        style={{
          background: 'var(--bg-card)', borderRadius: 18, padding: 32,
          minWidth: 420, minHeight: 320, boxShadow: '0 8px 40px #0008',
          position: 'relative', maxWidth: '90vw', maxHeight: '90vh', overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {!hideCloseButton && (
          <button
            onClick={onClose}
            style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', color: 'var(--text-primary)', fontSize: 22, cursor: 'pointer' }}
          >
            ×
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
